module.exports = __webpack_public_path__ + "img/Error-404.45374ebc.svg";